import { render, staticRenderFns } from "./rwgdForm.vue?vue&type=template&id=99bbdfdc&scoped=true"
import script from "./rwgdForm.vue?vue&type=script&lang=js"
export * from "./rwgdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bbdfdc",
  null
  
)

export default component.exports